export default "__VITE_ASSET__CBdFTRER__"